<div class="flex justify-content-center mt-4 bg-black-alpha-90">

  <div class="grid gap-3 col-12 bg-black-alpha-90">
    <div class="col-12">
      <CustomTitle [title]="title() "
                   styleClass=" font-23 text-white text-uppercase font-principal font-medium mb-0"/>
      <h4 class="font-16 text-white font-principal mt-1 font-light">
        {{translation.subtitle}}
      </h4>
    </div>

    <div class="col-12 md:col-5 grid flex-column gap-2">
      <div class="col-6 w-full p-3  bg-black-alpha-90 border-1 border-round-2xl border-gray-900">
        <h3 class="font-20 font-weight-medium text-white">{{ translation?.descripcionCampo }}</h3>
        <textarea rows="8" cols="8" class="w-full border-white-alpha-30 border-round-2xl
         text-white bg-black-alpha-90"
                  autoResize="false" pInputTextarea [(ngModel)]="inputText"
                  [maxlength]="maxlength" [placeholder]="translation.placeholder"></textarea>
        <div class="flex justify-content-end mr-4 gap-3">
          <button pButton type="button" class="mt-3 button-action p-button-outlined"
                  [disabled]="isLoading" (click)="getResponse()">
            <span class="font-16 font-principal font-medium">
              {{response? translation.reload : translation.send }} </span>
            <i class="pi mx-2" [ngClass]="[response ? 'pi-sync' : 'pi-send']"></i>
          </button>
        </div>

      </div>
      <div class="col-6 w-full bg-black-alpha-90 border-1 border-round-2xl border-gray-900">

        <div class="col-12 p-3 mt-2 border-round-2xl
       container-response border-0 scrollbar-thin-gray">
          <h2 class="font-18 text-white font-weight-medium">{{ translation?.respuesta }}</h2>
          @if (responseText) {
            <div class="text-white" [innerHtml]=" responseText | safeResource: 'html' "></div>
          }
          @if (isLoading) {
            <p-skeleton height="3rem" styleClass="mb-2 bg-gray-700"/>
            <div class="flex gap-5">
              <p-skeleton height="3rem" width="20rem" styleClass="mb-2 bg-gray-700 "/>
            </div>
            <p-skeleton height="4rem" styleClass="mb-2 bg-gray-700"/>


          }
        </div>
      </div>
    </div>
    <div class="col-12 md:col-7 bg-black-alpha-90 border-1 chart-area
     border-gray-900 border-round-2xl flex flex-column gap-3 overflow-y-auto scrollbar-thin-gray py-4 px-3">
      @if (typeChart) {
        @for (item of charts; track $index) {
          <div class="bg-black-alpha-90 border-round-2xl p-3 border-1 ">
            <p-chart class="chartDiv" [type]="typeChart"
                     height="400px" [style]="item.styles"
                     [class]="item.class" [data]="item.datasets" [options]="item.options"
                     [responsive]="true"/>
          </div>
        }
      }

      @if (configTable.columns?.length > 0) {
        <div class="w-full  bg-black-alpha-90 border-round-2xl border-1 p-3">
          <custom-table [config]="configTable" />
        </div>
      }
    </div>
  </div>
</div>
